module.exports = __webpack_public_path__ + "assets/images/alerta423311a.png";